import React, { useCallback } from "react";
import { Button } from "@medentic/polaris-react";
import { ClipboardIcon } from "@medentic/polaris-icons";
import { useDispatch } from "react-redux";
import { showToast } from "@shared/lib";

interface CopyToClipboardProps {
  text: string;
  accessibilityLabel?: string;
  variant?: "primary" | "secondary" | "tertiary";
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  accessibilityLabel,
  variant = "tertiary",
}) => {
  const dispatch = useDispatch();
  
  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(
        showToast({
          message: `Copied ${text} to clipboard`,
          type: "success",
        })
      );
    } catch {
      dispatch(
        showToast({
          message: "Failed to copy to clipboard",
          type: "error",
        })
      );
    }
  }, [text, dispatch]);

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Button
        variant={variant}
        onClick={handleCopy}
        icon={ClipboardIcon}
        accessibilityLabel={accessibilityLabel || `Copy ${text} to clipboard`}
      />
    </div>
  );
};

export default CopyToClipboard; 
